export default "__VITE_ASSET__D7YeO5Ab__"